// extracted by mini-css-extract-plugin
export default {"container":"REAogX","titleAndContent":"t0n8Cv","title":"q1o5vP","subtitle":"KB8Vdc","subtitleText":"j3QWxL","content":"wDRIx6","extraFooterSpacing":"CcfWaN"};